import(/* webpackMode: "eager", webpackExports: ["MarketingNav"] */ "/vercel/path0/components/shared/marketing-nav.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
